export default {
    formReadAllBegin(state) {
        state.loading = true;
    },

    formReadAllSuccess(state, data) {
        state.loading = false;
        state.data = data.list;
        state.total = data.total;
    },

    formReadAllErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    formAddBegin(state) {
        state.loading = true;
    },

    formAddSuccess(state) {
        state.loading = false;
    },

    formAddErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    formUpdateBegin(state) {
        state.loading = true;
    },

    formUpdateSuccess(state) {
        state.loading = false;
    },

    formUpdateErr(state, err) {
        state.loading = false;
        state.error = err;
    },
};